module.exports = __webpack_public_path__ + "static/photo-coaching-7cbecf4eea2b7f194dbfc2980d594c9a.png";